module.exports = __webpack_public_path__ + "img/entry-choice.80392656.svg";